<div class="info-tooltip">
  <mat-icon
    [matTooltip]="tooltip"
    [matTooltipPosition]="'below'"
    class="info-tooltip__icon"
  >
    info
  </mat-icon>
</div>
